export const formItemLayout = {
  wrapperCol: {
    span: 21,
  },
  labelCol: {
    span: 3,
  },
}
